module.exports = __webpack_public_path__ + "img/bandera_rellena.46c3b845.svg";